import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { Users, Trophy, Grid3x3, ArrowLeft } from "lucide-react";
import Navbar from "../../components/Navbar";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin/users", label: "Utilisateurs", icon: Users },
  { to: "/admin/classement", label: "Classement", icon: Trophy },
  { to: "/admin/plateau", label: "Plateau", icon: Grid3x3 },
];

export default function AdminLayout() {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-tribal">
        <div className="text-[color:var(--text-secondary)] tracking-[0.2em] text-sm">CHARGEMENT…</div>
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/lobby" replace />;
  }

  return (
    <div className="min-h-screen bg-tribal">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
          <div>
            <p className="text-xs tracking-[0.3em] text-[color:var(--primary)] mb-1">ADMINISTRATION</p>
            <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">Panneau admin</h1>
          </div>
          <Link
            to="/lobby"
            className="inline-flex items-center gap-2 text-sm text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)]"
          >
            <ArrowLeft size={16} /> Retour au jeu
          </Link>
        </div>

        <nav className="flex flex-wrap gap-2 mb-8">
          {NAV.map(({ to, label, icon: Icon }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition border ${
                  active
                    ? "bg-[color:var(--primary)]/15 border-[color:var(--primary)] text-[color:var(--primary)]"
                    : "glass border-[color:var(--border)] text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)]"
                }`}
              >
                <Icon size={16} /> {label}
              </Link>
            );
          })}
        </nav>

        <Outlet />
      </div>
    </div>
  );
}
